import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { primaryLogoInverted } from '../../assets/v2';
import { WEB_APP_URL } from '../../constants/storeLinks';
import './navbar.css';

interface NavbarProps {
  isMobile: boolean;
  isTablet: boolean;
  openWaitlist?: () => void;
}

const SECTIONS: { id: string; label: string }[] = [
  { id: 'how-it-works', label: 'AI Inspection' },
  { id: 'business-tools', label: 'Business Tools' },
  { id: 'pricing', label: 'Pricing' },
  { id: 'about', label: 'About' },
];

const Navbar: React.FC<NavbarProps> = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const onHomeRoutes =
    location.pathname === '/' ||
    location.pathname === '/InterNACHI-discount-ji394su3pa7' ||
    location.pathname === '/InterNACHI-discount-ji394su3pa7/';

  const scrollTo = (id: string) => {
    setOpen(false);
    if (onHomeRoutes) {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    }
  };

  const handleFreeTrial = () => {
    scrollTo('download');
  };

  const handleSignIn = () => {
    setOpen(false);
    window.open(WEB_APP_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <nav className={`v2-nav ${open ? 'v2-nav--open' : ''}`}>
        <div className="v2-nav__inner">
          <button
            type="button"
            className="v2-nav__logo"
            onClick={() => scrollTo('home')}
            aria-label="Morph home"
          >
            <img src={primaryLogoInverted} alt="Morph" />
          </button>
          <div className="v2-nav__links">
            {SECTIONS.map((s) => (
              <button
                key={s.id}
                type="button"
                className="v2-nav__link"
                onClick={() => scrollTo(s.id)}
              >
                {s.label}
              </button>
            ))}
          </div>
          <div className="v2-nav__actions">
            <button
              type="button"
              className="v2-nav__signin"
              onClick={handleSignIn}
            >
              Sign In
            </button>
            <button
              type="button"
              className="v2-nav__trial"
              onClick={handleFreeTrial}
            >
              FREE TRIAL
            </button>
          </div>
          <button
            type="button"
            className={`v2-nav__hamburger ${open ? 'v2-nav__hamburger--open' : ''}`}
            aria-label="Menu"
            aria-expanded={open}
            onClick={() => setOpen((o) => !o)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      <div
        className={`v2-mobilenav ${open ? 'v2-mobilenav--open' : ''}`}
        aria-hidden={!open}
      >
        <div className="v2-mobilenav__links">
          {SECTIONS.map((s) => (
            <button key={s.id} type="button" onClick={() => scrollTo(s.id)}>
              {s.label}
            </button>
          ))}
        </div>
        <div className="v2-mobilenav__actions">
          <button
            type="button"
            className="v2-mobilenav__signin"
            onClick={handleSignIn}
          >
            Sign In
          </button>
          <button
            type="button"
            className="v2-nav__trial"
            onClick={handleFreeTrial}
          >
            FREE TRIAL
          </button>
        </div>
      </div>
    </>
  );
};

export default Navbar;
